import type { LabradorComponent, StandaloneComponent } from '@/types/component';

import { SliderSlide } from '@/components/Slider/Slide';
import { SliderSwiper } from '@/components/Slider/Swiper';
import { pathToComponent } from '@/utils/toComponent';

export const LabradorSlider: LabradorComponent = ({ type, data, meta }) => {
  let SliderComponent: StandaloneComponent = SliderSwiper;

  if (pathToComponent(meta.path) === 'SliderSlide') {
    SliderComponent = SliderSlide;
  }

  return <SliderComponent {...data} />;
};
